import '../../../icons'
import Email from '../../component/inputs/email/index'
import Button from '../../component/buttons/button/index'
import platformRedirect from '../../../mixins/platformRedirect'
import VueNotifications from 'vue-notifications'
import ErrorBlock from '../../component/error/index'
import PhoneToken from '../../component/inputs/phoneToken/index'
import {isNil, isNumber} from 'lodash'

export default {
  name: 'EmailVerification',
  mixins: [platformRedirect],
  notifications: {
    showErrorMsg: {
      type: VueNotifications.types.warn
    },
    showSucessMsg: {
      type: VueNotifications.types.info
    }
  },
  data () {
    return {
      email: '',
      phoneToken: null,
      isValid: this.$route.params.isValid,
      isPhoneVerifed: this.$route.params.isPhoneVerified,
      isActive: this.$route.params.isActive,
      isWaitingForNewToken: false,
      isWaitingTokenVerification: false,
      lang: this.$route.params.lang

    }
  },
  components: {
    'kw-email': Email,
    'kw-button': Button,
    'kw-error': ErrorBlock,
    'kw-token': PhoneToken
  },
  computed: {
    isEmailVerified () {
      return this.$route.params.isValid
    },
    isTokenPatternValid () {
      const token = this.phoneToken
      return !(isNil(token) || !isNumber(token) || token.toString().length !== 6)
    }
  },
  methods: {
    emitNewToken () {
      this.isWaitingForNewToken = true
      this.$http.get(`${process.env.API_URL}/user/phone-confirmation/${this.$route.query.user}/new-token`)
        .then((response) => {
          this.isWaitingForNewToken = false

          this.showSucessMsg({
            title: this.$i18n.t('New token send'),
            message: this.$i18n.t(response.body.message)
          })
        })
    },

    verifySMSToken () {
      if (!this.isTokenPatternValid) {
        this.showErrorMsg({
          title: this.$i18n.t('Invalid token format'),
          message: this.$i18n.t('The token format provided is not valid, it must contain 6 digits.')
        })
      }

      this.isWaitingTokenVerification = true

      this.$http.get(`${process.env.API_URL}/user/phone-confirmation/${this.$route.query.user}/${this.phoneToken}`)
        .then((response) => {
          this.isWaitingTokenVerification = false

          if (response.body.valid) {
            this.showSucessMsg({
              title: this.$i18n.t('Account verified and active'),
              message: this.$i18n.t('We are currently redirecting you to your personal area')
            })
            setTimeout(this.setTokenAndRedirect(response.body.token), 2000)
          } else {
            this.showErrorMsg({
              title: this.$i18n.t('Error'),
              message: this.$i18n.t('The token provided is not valid, please check your sms message, or ask for a new one.')
            })
          }
        })
    },
    redirect () {
      let url = `/${this.lang}/entrar/login`

      window.location.replace(url)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/views/EmailConfirmation/emailConfirmation.js